<template>
  <v-app>
    <v-main>
      <Navbar />
      <Cookiebar />
      <router-view />
      <div style="height:160px"></div>
      <Footer />
    </v-main>
    <Snackbar />
    <FloatingCart />
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Snackbar from "./components/Snackbar.vue";
import FloatingCart from "./components/start/FloatingCart.vue";
import Cookiebar from "./components/Cookiebar";

export default {
  name: "App",

  components: {
    Navbar,
    Footer,
    Snackbar,
    FloatingCart,
    Cookiebar
  },

  data: () => ({
    //
  })
};
</script>
